import React from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { jobProcess, categories } from "../../../../common/data/jobLanding";
import { Link } from "react-router-dom";

const Process = () => {
  return (
    <React.Fragment>
      <section className="section bg-light" id="process">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="text-center mb-5">
                <h1 className="mb-3 fw-semibold lh-base">
                  <span className="text-primary">Departments</span> at
                  CODEPLAYERS
                </h1>
                <p className="text-muted">
                  Connecting businesses with skilled ERP professionals is
                  simple. Post your project requirements, review qualified
                  candidates, and choose the right expert to drive your ERP
                  success.
                </p>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            {categories.map((item, key) => (
              <Col lg={4} md={6} key={key}>
                <Card className="shadow-none text-center py-3">
                  <CardBody className="py-4">
                    <div className="avatar-sm position-relative mb-4 mx-auto">
                      <div className="job-icon-effect"></div>
                      <div className="avatar-title bg-transparent text-success rounded-circle">
                        <i className={item.icon}></i>
                      </div>
                    </div>
                    <Link to="#!" className="to-link">
                      <h5 className="sm-semi-bold fs-17 pt-1">
                        {" "}
                        <strong>{item.lable}</strong>
                      </h5>
                    </Link>

                    {item.requirement.map((group, groupIdx) => (
                      <div
                        key={groupIdx}
                        className="d-flex align-items-center gap-2 mb-2 text-start"
                        style={{ flexWrap: "wrap", maxWidth: "100%" }} // Ensure no overflow
                      >
                        {/* Icon */}
                        <div className="flex-shrink-0">
                          <div className="avatar-xs icon-effect">
                            <div className="avatar-title bg-transparent text-success rounded-circle h2">
                              <i className="ri-check-fill"></i>
                            </div>
                          </div>
                        </div>

                        {/* Requirement Text */}
                        <div className="flex-grow-1">
                          <p
                            className="mb-0"
                            style={{
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                            }}
                          >
                            {group.join(", ")}
                          </p>
                        </div>
                      </div>
                    ))}
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Process;
